var _path, _path2, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAlignCenter = function SvgAlignCenter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 25,
    viewBox: "0 0 20 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5355 6.17157L10.3536 9.35355C10.1583 9.54882 9.84171 9.54882 9.64645 9.35355L6.46447 6.17157C6.2692 5.97631 6.2692 5.65973 6.46447 5.46447C6.65973 5.2692 6.97631 5.2692 7.17157 5.46447L9.5 7.79289L9.5 0L10.5 4.3714e-08L10.5 7.79289L12.8284 5.46447C13.0237 5.2692 13.3403 5.2692 13.5355 5.46447C13.7308 5.65973 13.7308 5.97631 13.5355 6.17157Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.46447 18.8284L9.64645 15.6464C9.84171 15.4512 10.1583 15.4512 10.3536 15.6464L13.5355 18.8284C13.7308 19.0237 13.7308 19.3403 13.5355 19.5355C13.3403 19.7308 13.0237 19.7308 12.8284 19.5355L10.5 17.2071L10.5 25H9.5L9.5 17.2071L7.17157 19.5355C6.97631 19.7308 6.65973 19.7308 6.46447 19.5355C6.2692 19.3403 6.2692 19.0237 6.46447 18.8284Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 12H20V13H0V12Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAlignCenter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/alignCenter.37a90793.svg";
export { ForwardRef as ReactComponent };